/**
 * `MarkdownRenderer` chargé À LA DEMANDE.
 *
 * Pourquoi : le moteur Markdown (`react-markdown` + `remark` + `micromark` +
 * `unified`, 138 modules) était soudé au chunk d'entrée parce que le volet
 * d'aide vit dans la COQUILLE de l'application. Toute page le téléchargeait
 * donc, y compris les 99 % de visites où personne n'ouvre l'aide.
 *
 * ⚠️ Importez TOUJOURS `MarkdownRenderer` depuis ce module (ou depuis
 * `@/components/knowledge`, qui le réexporte) et jamais depuis
 * `./MarkdownRenderer` : un seul import statique suffit à remettre les 138
 * modules sur le chemin critique. Le garde-fou `scripts/check-bundle-budget.mjs`
 * s'en aperçoit au poids, mais après coup.
 */
import { Suspense, lazy } from 'react'

import { Skeleton } from '@/components/ui/skeleton'
import type { MarkdownRendererProps } from './MarkdownRenderer'

const MarkdownRendererImpl = lazy(() =>
    import('./MarkdownRenderer').then((m) => ({ default: m.MarkdownRenderer })),
)

/** Attente : trois lignes de texte, pas un spinner — le contenu arrive en un clin d'œil. */
function MarkdownFallback() {
    return (
        <div className="space-y-2" aria-hidden>
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
        </div>
    )
}

export function MarkdownRenderer(props: MarkdownRendererProps) {
    return (
        <Suspense fallback={<MarkdownFallback />}>
            <MarkdownRendererImpl {...props} />
        </Suspense>
    )
}

export type { MarkdownRendererProps }
